import { create } from 'zustand';

export const ConnectionState = {
  Authenticating: 'authenticating',
  Connected: 'connected',
  Connecting: 'connecting',
  Disconnected: 'disconnected',
  Subscribing: 'subscribing',
} as const;

export type ConnectionState = typeof ConnectionState[keyof typeof ConnectionState];

interface HubState {
  connectionState: ConnectionState;
  setConnectionState(state: ConnectionState): void;
  reset(): void;
}

export const useHubStore = create<HubState>((set) => ({
  connectionState: ConnectionState.Disconnected,

  reset: () => set({ connectionState: ConnectionState.Disconnected }),

  setConnectionState: (state) => set({ connectionState: state }),
}));

/** Selector: true when fully connected and subscribed */
export const selectIsConnected = (state: HubState) => state.connectionState === ConnectionState.Connected;
